import { Component, ViewEncapsulation } from '@angular/core';
import { MenuItem, TabMenuModule } from '@sym-ui/toolkit';

import { AuditNotificationsComponent } from '../../audit-notifications/src/audit-notifications.component';
import { NotificationsComponent } from '../../notifications/src/notifications.component';

type NotificationPanelId = 'spanva' | 'audit';

interface NotificationTab extends MenuItem {
  id: NotificationPanelId;
}

const TABS: NotificationTab[] = [
  { id: 'spanva', label: 'SpanVA' },
  { id: 'audit', label: 'Audit' },
];

/**
 * Tabbed notification-settings page shown under Settings > Notification.
 * Each tab renders its own fully independent notification table/state
 * (SpanVA's per-instance table, or Audit's tenant-wide list).
 */
@Component({
  selector: 'casb-notification-settings-panels',
  standalone: true,
  templateUrl: './notification-settings-panels.component.html',
  styleUrl: './notification-settings-panels.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [TabMenuModule, AuditNotificationsComponent, NotificationsComponent],
})
export class NotificationSettingsPanelsComponent {
  tabs = TABS;
  activeTab: NotificationTab = TABS[0];
}
